var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "display-flex flex-row flex-items-end flex-content-between",
      staticStyle: { gap: "var(--spacing-2xl)" },
    },
    [
      _c(
        "nav",
        {
          staticClass: "tabs size-lg",
          staticStyle: { "--tab-font-weight": "var(--font-weight-normal)" },
        },
        [
          _c(
            "button",
            {
              class: _vm.tabClass("packs"),
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.selectTab("packs")
                },
              },
            },
            [
              _c("font-awesome-icon", {
                staticClass: "margin-right-3xs",
                attrs: { icon: _vm.$v6.solid.faSwatchbook, size: "lg" },
              }),
              _vm._v(" "),
              _vm._m(0),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              class: _vm.tabClass("categories"),
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.selectTab("categories")
                },
              },
            },
            [
              _c("font-awesome-icon", {
                staticClass: "margin-right-3xs",
                attrs: { icon: _vm.$v6.solid.faFolder, size: "lg" },
              }),
              _vm._v(" "),
              _vm._m(1),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c("wa-select-custom", {
        staticClass: "size-sm margin-bottom-md",
        attrs: {
          "is-full-width": false,
          "custom-style": {
            "--input-font-weight": "var(--font-weight-normal)",
            "--input-padding":
              "var(--spacing-sm) var(--input-padding-horizontal)",
          },
          "is-minimal": "",
          label: "Choose a version of Font Awesome",
          "select-whitespace": "sm",
          options: _vm.options,
          value: _vm.$releases.active.version,
        },
        on: { change: _vm.versionChanged },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", [
      _c("span", { staticClass: "display-none tablet:display-inline" }, [
        _vm._v("Icon "),
      ]),
      _vm._v("Packs"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", [
      _c("span", { staticClass: "display-none tablet:display-inline" }, [
        _vm._v("Icon "),
      ]),
      _vm._v("Categories"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }